import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie-service';

import { AuthConfig, AuthProvider } from './auth.provider';

@Injectable()
export abstract class CookieProvider implements AuthProvider {

  constructor(protected cookieService: CookieService, protected authConfig: AuthConfig) { }

  isAuthenticated() {
    return this.cookieService.check(this.authConfig.cookie);
  }

  signOut(): Observable<boolean> {
    this.clearCookie();
    return Observable.of(true);
  }

  intercept(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({ withCredentials: true });
  }

  protected clearCookie() {
    if (this.cookieService.check(this.authConfig.cookie))
      this.cookieService.delete(this.authConfig.cookie);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/providers/cookie.provider.ts